import { render, staticRenderFns } from "./ServeItemList.vue?vue&type=template&id=548f68b4"
import script from "./ServeItemList.vue?vue&type=script&lang=js"
export * from "./ServeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports